import React from 'react';
import { Box, Typography,  CircularProgress } from '@mui/material';
import { useTranslation } from 'react-i18next';
import ClientProfileForm from '../../components/client/ClientProfileForm';
import { useClient } from '../../hooks/useClient';

/**
 * Client profile page for viewing and updating profile information
 */
const Profile: React.FC = () => {
  const { t } = useTranslation();
  const { isLoading } = useClient();
  
  if (isLoading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" height="400px">
        <CircularProgress />
      </Box>
    );
  }
  
  return (
    <Box px={6} py={4}>
      <Typography variant="h2" gutterBottom>
        {t('clientProfile.myProfile')}
      </Typography>
      
      <ClientProfileForm isOnboarding={false} />
    </Box>
  );
};

export default Profile;